<template>
	<div>
		<el-upload
			ref="upload"
			:action="action"
			:http-request="customUpload"
			:file-list="internalFileList"
			:limit="limit"
			:multiple="multiple"
			:before-upload="beforeUpload"
			:on-remove="handleRemove"
			:on-success="handleSuccess"
			:on-exceed="handleExceed"
			:auto-upload="true"
			list-type="text">
			<el-button icon="el-icon-upload2" size="small">
				<span style="font-size: 12px">{{ title }}</span>
			</el-button>
		</el-upload>

		<div class="el-upload__tip">
			<template v-if="$slots.tip">
				<slot name="tip"></slot>
			</template>
			<template v-else-if="showTip">支持 {{ accept.join('、') }}，单个文件不超过 {{ maxSize }}MB</template>
		</div>
	</div>
</template>

<script>
	import { fileUpload } from '@/api/file/fileApi.js';

	export default {
		name: 'FileUpload',
		props: {
			modelValue: {
				type: Array,
				default: () => [],
			},
			title: {
				type: String,
				default: '上传房产证、土地证等',
			},
			action: {
				type: String,
				default: '',
			},
			limit: {
				type: Number,
				default: 5,
			},
			showTip: {
				type: Boolean,
				default: true,
			},
			multiple: {
				type: Boolean,
				default: true,
			},
			maxSize: {
				type: Number,
				default: 10, // MB
			},
			accept: {
				type: Array,
				default: () => ['jpg', 'png', 'pdf', 'docx'],
			},
		},
		data() {
			return {
				internalFileList: [], // 内部状态
			};
		},
		watch: {
			modelValue: {
				immediate: true,
				handler(val) {
					this.internalFileList = val;
				},
			},
		},
		methods: {
			beforeUpload(file) {
				const ext = file.name.split('.').pop().toLowerCase();
				if (!this.accept.includes(ext)) {
					this.$message.error(`不支持 ${ext} 文件`);
					return false;
				}
				const isLtSize = file.size / 1024 / 1024 < this.maxSize;
				if (!isLtSize) {
					this.$message.error(`文件不能超过 ${this.maxSize}MB`);
					return false;
				}
				return true;
			},
			customUpload(options) {
				const { file, onSuccess, onError } = options;
				const formData = new FormData();
				formData.append('file', file);

				fileUpload(formData)
					.then(res => {
						onSuccess(res);
					})
					.catch(err => {
						onError(err);
					});
			},
			handleSuccess(response, file, fileList) {
				this.internalFileList = fileList;
				this.$emit('update:modelValue', fileList); // 同步父组件
				this.$emit('success', response, fileList);
			},
			handleRemove(file, fileList) {
				this.internalFileList = fileList;
				this.$emit('update:modelValue', fileList);
				this.$emit('remove', file, fileList);
			},
			handleExceed() {
				this.$message.warning(`最多只能上传 ${this.limit} 个文件`);
			},
			reset() {
				this.internalFileList = [];
				this.$refs.upload.clearFiles();
				this.$emit('update:modelValue', []);
			},
		},
	};
</script>

<style scoped>
	.el-upload__tip {
		margin-top: 5px;
		color: #999;
	}
</style>
